import { Box, Checkbox, lighten } from 'enova-frontend-components';
import { useTranslation } from 'react-i18next';
import { FC, ReactNode } from 'react';
import { FieldError } from 'react-hook-form';

import styled from '../../../../../../../styled';
import { ErrorMessage } from '../../errors';

interface Props {
  value?: boolean;
  onChange: (checked: boolean) => void;
  children: ReactNode;
  i18nPrefix: string;
  i18nPostfix?: string;
  error?: FieldError;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const SelectableAreaWrapper = styled(({ isSelected, ...props }) => <Box {...props} />)<{ isSelected?: boolean }>`
  background-color: ${({ theme, isSelected }) =>
    // This color is copied from former solution. Consider changing it using a theme color directly.
    isSelected ? lighten(theme.palette.primary.main, 0.93) : 'white'};
  box-shadow: ${({ theme, isSelected }) =>
    isSelected
      ? `20px 0 ${lighten(theme.palette.primary.main, 0.93)}, -20px 0 ${lighten(theme.palette.primary.main, 0.93)}`
      : ''};
`;

export const CheckboxArea: FC<Props> = ({ value, onChange, children, i18nPrefix, i18nPostfix, error }) => {
  const { t } = useTranslation('', { keyPrefix: i18nPrefix });

  return (
    <SelectableAreaWrapper pt={3} isSelected={!!value}>
      <Checkbox
        checked={value}
        error={!!error}
        helperText={t([`helperText.${i18nPostfix}`, 'helperText'])}
        onChange={(e, checked) => {
          onChange(checked);
        }}
        label={t(`label`)}
      />
      {value && <Box p={3}>{children}</Box>}
      {error && <ErrorMessage error={error} />}
    </SelectableAreaWrapper>
  );
};
